import React from "react";
import style from "./PropertyDetails.module.css";
import "./carouselStyling.css";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-gallery-carousel/dist/index.css";
import { useLocation } from "react-router-dom";
import "react-image-gallery/styles/css/image-gallery.css";
import * as axios from 'axios';
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { getWebsiteSettings } from "../../Api/commonApis";
import { getPropertyDetails } from './../../Api/propertiesApi';
import subtract from '../../assets/icons/subtract.svg';
import add from '../../assets/icons/add.svg';
import bathroom from '../../assets/icons/bathroom.svg';
import bedrooms from '../../assets/icons/bedrooms.svg';
import kitchen from '../../assets/icons/kitchen.svg';
import parking from '../../assets/icons/parking.svg';
import space from '../../assets/icons/space.svg';
import user from '../../assets/icons/user.svg';
import { filterLanguage, filterProperties } from './../../utilities/filterFunction';
import { basename, host_url } from './../../configiration/config';
import Callender from "./callender";
import { useParams } from 'react-router-dom'
import { imgResize } from './../../utilities/imageResize';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css';
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";


function PropertyDetails() {
    const [t, i18n] = useTranslation();
    let navigate = useNavigate();
    const { pathname } = useLocation();
    const { slug } = useParams();

    var myDate = new Date();
    //add a day to the date
    myDate.setDate(myDate.getDate() );
    const [minDate] = useState(new Date());
    const [checkinDate, setCheckinDate] = useState(new Date());
    const [checkoutDate, setCheckoutDate] = useState(myDate);
    const [guestsValue, setGuestsValue] = useState(1);
    const [weatherArray, setWeatherArray] = useState([]);
    const [ads, setads] = useState([]);
    const [propertyDetails, setpropertyDetails] = useState('');
    const [facilites, setFaclities] = useState([]);
    const [location, setLocation] = useState({});
    const [libraries] = useState(['places']);
    const [whatsappMsg, setwhatsappMsg] = useState('');
    const [contactData, setcontactData] = useState();
    const [propertyLocale, setpropertyLocale] = useState();
    const [areaByLanguage, setareaByLanguage] = useState();
    const [images, setImages] = useState([]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);


    useEffect(() => {
        let whatsapp = `Hey there ,Please i want to book your property ' ${propertyLocale && propertyLocale.length > 0 && propertyLocale[0].title !== null && propertyLocale[0].title}'  for ${guestsValue} guests from ${moment(checkinDate, ["h:mm A"]).format("YYYY-MM-DD")} to ${moment(checkoutDate, ["h:mm A"]).format("YYYY-MM-DD")}  ${window.location.href}`;
        setwhatsappMsg(whatsapp)
        // eslint-disable-next-line
    }, [propertyLocale,guestsValue])

    // get About us
    useEffect(() => {
        getWebsiteSettings().then((res) => {
            let contacts = { ...contactData }
            contacts = res.data.data;
            setcontactData(contacts);
        })
        // eslint-disable-next-line
    }, []);

    //   Get all property details
    useEffect(() => {
        getPropertyDetails(slug).then((res) => {
            if (res.data.status === true) {
                let property = { ...propertyDetails };
                property = res.data.data.property;
                setpropertyDetails(property);
                let facilities = { ...facilites }
                facilities = property.facilities
                setFaclities(facilities);
                // get ads values
                let ad = [...ads]
                ad = res.data.data.ads;
                setads(ad);
                let localesAtSelectedLanguage = filterLanguage(property.locales);
                let lang;
                if (i18n.language === 'en') {
                    lang = 'ar';
                } else if (i18n.language === 'ar') {
                    lang = 'en';
                }
                let localesAtDifferentLanguage = filterProperties(property.locales, lang);
                if (localesAtSelectedLanguage.length > 0) {
                    setpropertyLocale(localesAtSelectedLanguage)
                } else {
                    setpropertyLocale(localesAtDifferentLanguage)
                }
                setareaByLanguage(filterLanguage(property.area.locales))
            } else {
                // navigate(`${basename}/*`)
                navigate(`${basename}/not-found`)
            }
        }).catch(()=>{
            navigate(`${basename}/not-found`)
        })
        // eslint-disable-next-line
    }, [])
    //set meta description and keywords
    useEffect(() => {
        if (propertyLocale && propertyLocale.length > 0) {
            const description = document.querySelector("meta[name='description']");
            description.setAttribute('content', propertyLocale[0].meta_description);
            const keywords = document.querySelector("meta[name='keywords']");
            keywords.setAttribute('content', propertyLocale[0].meta_keywords);
        }
    }, [propertyLocale])

    // set map location
    useEffect(() => {
        if (propertyDetails !== null) {
            let loc = { ...location }
            loc = { lat: parseFloat(propertyDetails.latitude), lng: parseFloat(propertyDetails.longitude) }
            setLocation(loc);

            if (propertyDetails.images && propertyDetails.images.length > 0) {
                setImages(propertyDetails.images.map((e) => {
                    return {image: `${host_url}/${e.file}`}
                }));
            }
        }
        // eslint-disable-next-line
    }, [propertyDetails])
    // get weather
    var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    useEffect(() => {
        if (location && location.lat) {
            axios({
                url: `https://api.weatherbit.io/v2.0/forecast/daily?lat=${location && location.lat ? location.lat : 31.22}&lon=${location && location.lng ? location.lng : 31.22}&key=ac5de92a302b43b489ca8a9b7ff46a4b`,
                method: "get",
            }).then((response) => {
                let weatherArr = [...weatherArray];
                for (let i = 0; i < 5; i++) {
                    weatherArr.push(response.data.data[i]);
                }
                setWeatherArray(weatherArr)
            })
        }
        // eslint-disable-next-line
    }, [location.lat]);

    //swiper stop on hover
    useEffect(() => {
        let swiper_containers = document.querySelectorAll('.swiper-container');
        for (let i = 0; i < swiper_containers.length; i++) {
            swiper_containers[i].addEventListener('mouseover', function() {
                var swiper = this.swiper;
                swiper.autoplay.stop();
            });

            swiper_containers[i].addEventListener('mouseleave', function() {
                var swiper = this.swiper;
                swiper.autoplay.start();
            });
        }
    }, [])

    // eslint-disable-next-line
    const [map, setMap] = useState(null);
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);
    const containerStyle = {
        width: "75%",
        height: "400px"
    };
    return (
        <div>
            {/* START OF HEADER SECTION */}
            {/*<div className={`${style.propertyDetailsHeader}`}>
                <div id="propertyimageCarousel" className={`carousel slide `} data-bs-ride="carousel">
                    <div className="carousel-inner">
                        {propertyDetails.images && propertyDetails.images.length > 0 && propertyDetails.images.map((property, i) => {
                            return (
                                <div key={property.id} className={`carousel-item ${i === 0 && 'active'} `} data-bs-interval='2500'>
                                    <img src={`${imgResize(property.file,1920,0)}`} className={`d-block w-100 ${style.carouselImg}`} alt="..." onError={(e) => { e.target.src = noImage }} />
                                </div>
                            )
                        })}
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#propertyimageCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#propertyimageCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>*/}

            <div className="propertySwiper">
                {/*{images && images.length > 0 &&
                    <ReactFullscreenSlideshow images={images}/>
                }*/}

                <Swiper
                    className={'swiper-container'}
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={"auto"}
                    coverflowEffect={{
                      rotate: 50,
                      stretch: 0,
                      depth: 100,
                      modifier: 1,
                      slideShadows: true,
                    }}

                    pagination={false}
                    navigation={true}
                    modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}

                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: true,
                    }}

                >
                    {images && images.length > 0 && images.map((i) => {
                        return (
                            <SwiperSlide>
                                <img src={i.image} alt='slide'/>
                            </SwiperSlide>
                        )})
                    }
                </Swiper>
            </div>
            {/* END OF HEADER SECTION */}

            <div className={`${style.myCustomContainer}  mx-auto my-2`}>
                <div className={`${style.propertyContainer} w-100 row mx-0`}>
                    <span className={`${style.propertyHeader} ps-0`}>
                        <span className="homeWord" onClick={() => {
                            navigate(`${basename}/`);
                        }}
                        >
                            {t('home')}
                        </span>
                        / <span>{t('locations')}</span> /
                        <span
                            className="locationWord"
                            onClick={() => {
                                navigate(`${basename}/search-results`, { state: { area: propertyDetails && propertyDetails.area } });
                            }}
                        >
                            {areaByLanguage && areaByLanguage[0].name}
                        </span>
                    </span>
                    <div
                        className={`${style.propertyDetails} row col-sm-12 col-md-8 col-lg-9`}
                    >
                        <div
                            className={`${style.detailSingleDiv} ${style.detailsPilotDiv} ${style.borderBottom} pb-4`}
                        >
                            {propertyLocale && propertyLocale.length > 0 &&
                                <div className='mt-3'>
                                    <div className={`${style.propertyTitle}`}>{propertyLocale[0].title !== null && propertyLocale[0].title}</div>
                                    <div className={style.propertyDetailsPargraph}>
                                        {propertyLocale[0].description !== null && parse(propertyLocale[0].description)}
                                    </div>
                                </div>
                            }
                        </div>
                        {/******************** property specifications ***************************/}
                        {propertyDetails ?
                            <div className={`${style.detailSingleDiv} ${style.borderBottom} py-4`}>
                                <h6 className={`${style.DivTitle} mb-4`}>{t('property-specification')}</h6>
                                <div
                                    className={`${style.facilitiesStyling} ${style.specifications} row row-cols-2 row-cols-md-3 row-cols-lg-5 `}
                                >
                                    {propertyDetails.space !== 0 ?
                                    <div className='col'>
                                        <div className={`${style.item} d-flex`}>
                                            <span><img src={space} alt='space' /></span>
                                            <span>{t('space')} {propertyDetails.space} {t('meter')} <sup>2</sup></span>
                                        </div>
                                    </div>
                                    :""}
                                    <div className='col'>
                                        <div className={`${style.item} d-flex`}>
                                            <span><img src={bedrooms} alt='bedrooms' /></span>
                                            <span>{propertyDetails.bedrooms} {t('bedrooms')}</span>
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className={`${style.item} d-flex`}>
                                            <span><img src={bathroom} alt='bathrooms' /></span>
                                            <span>{propertyDetails.bathrooms} {t('bathrooms')}</span>
                                        </div>
                                    </div>

                                    <div className='col'>
                                        <div className={`${style.item} d-flex`}>
                                            <span><img src={kitchen} alt="kitchen" /></span>
                                            <span>{propertyDetails.kitchens} {t('kitchens')}</span>
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className={`${style.item} d-flex`}>
                                            <span><img src={parking} alt='parking' /></span>
                                            <span>{propertyDetails.parkings} {t('parkings')}</span>
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className={`${style.item} d-flex`}>
                                            <span><img src={user} alt='parking' /></span>
                                            <span>{propertyDetails.person} {t('guests')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div> : ""}
                        {/******************** Facilities ***************************/}
                        <div
                            className={`${style.detailSingleDiv} ${style.borderBottom} py-4`}
                        >
                            <h6 className={`${style.DivTitle} mb-4`}>{t('facilites')}</h6>
                            <div
                                className={`${style.facilitiesStyling} ${style.facilities} `}
                            >
                                {facilites && facilites.length > 0 && facilites.map((faclity) => {
                                    let selectedFacilty = filterLanguage(faclity.locales)
                                    return (
                                        <div key={faclity.slug} className={`${style.item} `}>
                                            <span> <img src={`${imgResize(faclity.image,24,24)}`} alt={faclity.slug} /></span>
                                            <span>{selectedFacilty.length > 0 && selectedFacilty[0].name}</span>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        {/* House Rules */}
                        <div className={`${style.detailSingleDiv} ${style.borderBottom} py-4`}>
                            <h6 className={`${style.DivTitle} mb-4`}>{t('house-rules')}</h6>
                            <div className={`${style.facilitiesStyling}`}>
                                {/* <p>-No smoking.</p> */}
                                {propertyLocale && propertyLocale.length > 0 &&
                                    <div className="pb-3">
                                        {propertyLocale[0].house_rules !== null && parse(propertyLocale[0].house_rules)}
                                    </div>
                                }
                            </div>
                            {/* Cancellation */}
                            <h6 className={`${style.DivTitle} mb-4`}>{t('cancellation')}</h6>
                            <div className={`${style.facilitiesStyling}`}>
                                {propertyLocale && propertyLocale.length > 0 &&
                                    <div className="pb-0">
                                        {propertyLocale[0].cancellation !== null && parse(propertyLocale[0].cancellation)}
                                    </div>
                                }
                            </div>
                        </div>
                        {/* callender */}
                        {/* Availability */}
                        {propertyDetails && propertyDetails.selected_dates.length > 0 &&
                            <div className={`${style.detailSingleDiv} ${style.availabilityContainer} py-4`}>
                                <h6 className={`${style.DivTitle} mb-4`}>{t('availabilty')}</h6>
                                <div className={`${style.CalenderContainer}`}>
                                    <Callender checkIn={setCheckinDate} checkOut={setCheckoutDate}/*  setVisibleToast={setVisibleToast}  */ selectedValue={propertyDetails && propertyDetails.selected_dates} />
                                </div>
                            </div>
                        }
                        {/* Location */}
                        <div className={`${style.detailSingleDiv} py-4`}>
                            <h6 className={`${style.DivTitle} mb-4`}>{t('location')}</h6>
                            {location && location.lat ?
                                <div className={`${style.MapContainer}`}>
                                    <LoadScript id="script-loader" googleMapsApiKey={process.env.REACT_APP_MAP_KEY}
                                        libraries={libraries}>
                                        <GoogleMap mapContainerStyle={containerStyle} center={location} zoom={18} onUnmount={onUnmount} draggable={false}>
                                            <Marker position={location} draggable={false} />
                                        </GoogleMap>
                                    </LoadScript>
                                </div>
                                : ""}
                        </div>
                    </div>
                    <div className={`${style.aside} col-sm-12 col-md-4 col-lg-3`}>
                        <div className={`${style.stickyAside}`}>
                            {/* Reservation section */}
                            <aside className={`${style.reservationDetails}`}>
                                <h5>{t('your-reservation')}</h5>
                                {/* {visibleToast && 
                                    <Expire delay="3000">Your dates are available</Expire>
                                } */}
                                <div className={`${style.reservationInputs}`}>
                                    <div
                                        className={`${style.inputField} ${style.searchElement} d-flex align-items-start mb-3`}
                                    >
                                        <span>{t('check-in')}</span>
                                        <DatePickerComponent
                                            className={`dropdown ${style.mates} e-input-group`}
                                            id="datepicker"
                                            format="E, d MMM y"
                                            value={checkinDate}
                                            min={minDate}
                                            onFocus={e => e.target.blur()}
                                            onChange={(newValue) => { setCheckinDate(newValue.target.value);/*  setMinCheckoutDate(newValue.target.value);  */ }}
                                        />
                                    </div>
                                    <div
                                        className={`${style.inputField} ${style.searchElement} d-flex align-items-start mb-3`}
                                    >
                                        <span>{t('check-out')}</span>
                                        <DatePickerComponent
                                            className={`dropdown ${style.mates} e-input-group`}
                                            id="datepicker"
                                            format="E, d MMM y"
                                            value={checkoutDate}
                                            min={checkinDate}
                                            onFocus={e => e.target.blur()}
                                            onChange={(newValue) => { setCheckoutDate(newValue.target.value) }}

                                        />
                                    </div>
                                    <div className={`${style.searchElement} mb-3`}>
                                        <span>{t('guests')}</span>
                                        <div
                                            className={`dropdown ${style.mates} position-relative`}
                                        >
                                            <input
                                                className="guestsInputFiled"
                                                type="text"
                                                readOnly
                                                value={guestsValue}
                                            />
                                            <div className={`${style.incrementSvgs} ${i18n.language === 'ar' ? style.incrementSvgsRight : style.incrementSvgsLeft}`}>
                                                <img src={subtract} alt='subtract' onClick={() => {
                                                    guestsValue > 1
                                                        ? setGuestsValue(guestsValue - 1)
                                                        : setGuestsValue(1);
                                                }}
                                                />
                                                <img src={add} alt='add' onClick={() => {
                                                    setGuestsValue(guestsValue + 1);
                                                }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className={`${style.searchElement} ${style.WhatsBtn} mx-auto`}
                                    >
                                        <button className='w-100'>
                                            <a href={`https://wa.me/${contactData && contactData.whatsapp}?text=${whatsappMsg}`}
                                                className={`w-100`} target='_blank' rel="noreferrer">
                                                {t('book-via-whatsapp')}
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </aside>

                            {/* Weather section */}
                            <aside className={`${style.WeatherDetails} mt-4`}>
                                <h5>{propertyDetails && propertyDetails.area && propertyDetails.area.city && propertyDetails.area.city.name} weather</h5>
                                {weatherArray && weatherArray.length > 0 && (
                                    <div
                                        className={` d-flex align-items-center justify-content-between`}
                                    >
                                        <div className="d-flex flex-column align-items-start">
                                            <i
                                                className={`${style.weatherIcon} fa-solid fa-cloud-rain`}
                                            ></i>
                                            <span className={`${style.weatherDegree}`}>
                                                {weatherArray[0].temp}'C
                                            </span>
                                            {/* <span>Humidity: 45%</span> */}
                                            <span>Wind: {weatherArray[0].wind_spd}m/s</span>
                                        </div>

                                        <div>
                                            {weatherArray && weatherArray.length > 0 &&
                                                // eslint-disable-next-line 
                                                weatherArray.map((singleDay, i) => {
                                                    if (i !== 0) {
                                                        let m = new Date(singleDay.datetime);
                                                        return (
                                                            <div key={i} className="d-flex align-items-center justify-content-between">
                                                                <span className={`${style.dayName}`}>
                                                                    {days[m.getDay()]}{" "}
                                                                </span>
                                                                <span className={`${style.cloudIcon}`}>
                                                                    <img
                                                                        className="w-100"
                                                                        src={`https://www.weatherbit.io/static/img/icons/${singleDay.weather.icon}.png`} alt='' />
                                                                </span>
                                                                <span> {singleDay.temp}'C</span>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                        </div>
                                    </div>
                                )}
                            </aside>
                            {/* ADs section */}
                            {ads && ads.length > 0 ? ads.map((ad) => {
                                return (
                                    ad && ad.link ?
                                            <a href={ad.link} target='_blank' className='w-100 h-100' rel='noreferrer'>
                                                <aside
                                                    key={ad.slug}
                                                    className={`${style.ADs} mt-4`}
                                                    style={{ backgroundImage: `url(${imgResize(ad.image,406,0)})` }}
                                                >     </aside>
                                                </a> :
                                                 <aside
                                                    key={ad.slug}
                                                    className={`${style.ADs} mt-4`}
                                                    style={{ backgroundImage: `url(${imgResize(ad.image,406,0)})` }}
                                                ></aside>
                                )
                            }) : <div></div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PropertyDetails;
